import React, { Component } from 'react';
import { Container, Row, Col, ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText } from 'reactstrap';
import { API } from '../../Logic/API'
import { Storage } from '../../Logic/Storage';
import { GAME_ID } from '../../Logic/storageKeys';
import "../Spacing.css";

export class JoinGame extends Component {
    static displayName = JoinGame.name;

    constructor(props) {
        super(props);
        this.state = { games: [], loading : true };

        this.props.showHostingNav(false);

        API.get('/games')
            .then(resp => resp.json())
            .then(data => {
                this.setState({ games: data, loading: false });
            })
            .catch(e => {

            });
    }

    selectGame(gameId) {
        Storage.setSessionValue(GAME_ID, gameId);
        this.props.history.push('/play/join');
    }

    renderElement(element) {
        return (
            <Row>
                <Col className="hidden-md"></Col>
                <Col lg="6"><div className="space-top space-bottom">{element}</div></Col>
                <Col className="hidden-md"></Col>
            </Row>
            );
    }

    renderLoadingMessage() {
        return this.renderElement(
            <p className='text-lg-center'><em>Lade Spiele...</em></p>
        );
    }
    
    renderGames(games) {
        if (games.length === 0) {
            return this.renderElement(
                <p className='text-lg-center'><em>Aktuell sind keine Spiele eröffnet</em></p>
            );
        }
        return this.renderElement(
            <ListGroup>
                {games.map(game =>
                    <ListGroupItem key={game.Id} tag="button" onClick={() => this.selectGame(game.Id)}>
                        <ListGroupItemHeading><p className="font-weight-bold text-lg-center">{game.Name}</p></ListGroupItemHeading>
                        <ListGroupItemText className="text-center">{new Date(game.CreatedAtUtc).toLocaleDateString('de-CH')}</ListGroupItemText>
                    </ListGroupItem>
                    )}
            </ListGroup>
        );
    }

    render() {
        let availableGames = this.state.loading
            ? this.renderLoadingMessage()
            : this.renderGames(this.state.games);

        return (
            <Container>
                <Row>
                    <Col className="hidden-md"></Col>
                    <Col lg="6"><h2 className="text-lg-center space-top space-bottom">Spiel wählen</h2></Col>
                    <Col className="hidden-md"></Col>
                </Row>
                {availableGames}
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Game/JoinGame.jsx